import styled from 'styled-components';

export const TipsStyle = styled.div`
  width: 100%;
  height: auto;
  color: #000;
  opacity: 0.4;
`;
